
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexiNtA_znKj_zn_45wsEgsmLpyYSVS7XVZ24_KIDRjqK_10Meta } from "/app/src/pages/index.vue?macro=true";
import { default as loginat_45I4W6dhaKeU4e7R3nRygvy7k1_45w8CiYRML3dJJNP8Meta } from "/app/src/pages/login.vue?macro=true";
import { default as areasVfMNdRLqFPMEndbG3EmHGK5uVN7p57DrD68p7pAduy8Meta } from "/app/src/pages/bncc/areas.vue?macro=true";
import { default as index48uaR6ib75SJPimxFGzpaDayNsX0Vcv_K9aI6YozGK0Meta } from "/app/src/pages/bncc/index.vue?macro=true";
import { default as _91id_93dsaYlVLH7dh946HVyYO7HEh7PHmNnS7MPD3Ljf1q4ikMeta } from "/app/src/pages/agenda/[id].vue?macro=true";
import { default as _91id_93RHJ83kUmKTLvq3cNmU1vll_454hvWoMffEhvAl_bamu0UMeta } from "/app/src/pages/cursos/[id].vue?macro=true";
import { default as _91id_93lPnllVvDqF920uORgM_45GiueqQWcKSZGUj6hJNdzOCJMMeta } from "/app/src/pages/perfis/[id].vue?macro=true";
import { default as indexFRc8cYj6ssmG8R32gW2IXFmPrenySzaKD1rWqGYQVH8Meta } from "/app/src/pages/agenda/index.vue?macro=true";
import { default as indexNep2CEBHCAvYHqQQ_Jmrr_45iNLeHqb3nHH7R6NBL4Tc0Meta } from "/app/src/pages/cursos/index.vue?macro=true";
import { default as index5UNmVoO5dPRruU5KKa3Zvlzi_iFKcwSFGPkEnOm_45ptYMeta } from "/app/src/pages/perfis/index.vue?macro=true";
import { default as indexJTWRzU4Y_45qY_RoroUrXxA5Dkf5yumBJ2c34fa_w_VOMMeta } from "/app/src/pages/planos/index.vue?macro=true";
import { default as indexVitjngb7T3HR2IVZ8SDldxk_45UMby205AK25645_1DmkMeta } from "/app/src/pages/escolas/index.vue?macro=true";
import { default as objetivosEY7qhKX_45y1efxFnsMspZU3pIg8w2CsJUvTzRnXVy0n4Meta } from "/app/src/pages/bncc/objetivos.vue?macro=true";
import { default as indext8czWsM3LnjTNcS4hXWNo0xCGOhaD_SGTzHQa9nD2QAMeta } from "/app/src/pages/clientes/index.vue?macro=true";
import { default as indexWJRbe3d_ialkQsYK2ZAzK7sKWBpOIl2aoT82AOlzeZMMeta } from "/app/src/pages/usuarios/index.vue?macro=true";
import { default as tiposU0aleEvz_C2Um6QCdeo_45a5QaOxOPGg4gRRSHWUA9DswMeta } from "/app/src/pages/usuarios/tipos.vue?macro=true";
import { default as index5gPwjRqqvWWAmiF_TjCzhpcM1Jqs9yLcZjMQiibEK1QMeta } from "/app/src/pages/aplicativos/index.vue?macro=true";
import { default as indexF2MAVhWnV9ziWZmF9Bp8axEkXE2Cn5KpdGUpiv51oVQMeta } from "/app/src/pages/bncc/etapas/index.vue?macro=true";
import { default as _91id_93By4V2pAInGj7jSpcdUNBTqs1uf_Ired4WFDpdHQrHsAMeta } from "/app/src/pages/equipamentos/[id].vue?macro=true";
import { default as certificadoeeVAPUf_9nojivPW3rh9tpUT8S7NixizleOQJpYAncIMeta } from "/app/src/pages/cursos/certificado.vue?macro=true";
import { default as indexnGxBZhXnc_bjIdzAUIPA_gZ8ZsFH3zBFvQVJXhUIf_45wMeta } from "/app/src/pages/equipamentos/index.vue?macro=true";
import { default as aulasdN7CCmamYZz0A8aQds7u_45cLvt97yLmTIM31zf__45KYacMeta } from "/app/src/pages/escolas/[id]/aulas.vue?macro=true";
import { default as indexa8cuPOaOsehDcM_45TFWzYXrf3AY6cYNlZP_7Q10s7nMEMeta } from "/app/src/pages/escolas/[id]/index.vue?macro=true";
import { default as alunosZ04azhDCURz6guOKlC0iuq_DdRYX6vRQPAwMnb_454LGoMeta } from "/app/src/pages/escolas/[id]/alunos.vue?macro=true";
import { default as turmasXj9GITqeHYC3cSha_454ByoucZviBQgIIiqvu3dFa3Nj4Meta } from "/app/src/pages/escolas/[id]/turmas.vue?macro=true";
import { default as indexo6c5S7iF6MdB3TEQGHI9NVFVr96wIisnRM_45CvaSWJogMeta } from "/app/src/pages/bncc/etapas/[id]/index.vue?macro=true";
import { default as faixas9z62F6mjq32JveslE67ukMFyMrhJ4oPIGqOkoMCK3c4Meta } from "/app/src/pages/bncc/etapas/[id]/faixas.vue?macro=true";
import { default as educadoresNnyJNVn4f786l8r2qvY_45KUdVgKJSy5wuUuHtYXynGn8Meta } from "/app/src/pages/escolas/[id]/educadores.vue?macro=true";
import { default as equipamentosVzWgiU2VA3qBX8BV6oh6FsO960QO97PeMKqkcC1L0FIMeta } from "/app/src/pages/escolas/[id]/equipamentos.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: { ...(indexiNtA_znKj_zn_45wsEgsmLpyYSVS7XVZ24_KIDRjqK_10Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/src/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginat_45I4W6dhaKeU4e7R3nRygvy7k1_45w8CiYRML3dJJNP8Meta || {},
    component: () => import("/app/src/pages/login.vue")
  },
  {
    name: "bncc-areas",
    path: "/bncc/areas",
    component: () => import("/app/src/pages/bncc/areas.vue")
  },
  {
    name: "bncc",
    path: "/bncc",
    component: () => import("/app/src/pages/bncc/index.vue")
  },
  {
    name: "agenda-id",
    path: "/agenda/:id()",
    component: () => import("/app/src/pages/agenda/[id].vue")
  },
  {
    name: "cursos-id",
    path: "/cursos/:id()",
    meta: { ...(_91id_93RHJ83kUmKTLvq3cNmU1vll_454hvWoMffEhvAl_bamu0UMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/src/pages/cursos/[id].vue")
  },
  {
    name: "perfis-id",
    path: "/perfis/:id()",
    component: () => import("/app/src/pages/perfis/[id].vue")
  },
  {
    name: "agenda",
    path: "/agenda",
    component: () => import("/app/src/pages/agenda/index.vue")
  },
  {
    name: "cursos",
    path: "/cursos",
    meta: { ...(indexNep2CEBHCAvYHqQQ_Jmrr_45iNLeHqb3nHH7R6NBL4Tc0Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/src/pages/cursos/index.vue")
  },
  {
    name: "perfis",
    path: "/perfis",
    component: () => import("/app/src/pages/perfis/index.vue")
  },
  {
    name: "planos",
    path: "/planos",
    component: () => import("/app/src/pages/planos/index.vue")
  },
  {
    name: "escolas",
    path: "/escolas",
    component: () => import("/app/src/pages/escolas/index.vue")
  },
  {
    name: "bncc-objetivos",
    path: "/bncc/objetivos",
    component: () => import("/app/src/pages/bncc/objetivos.vue")
  },
  {
    name: "clientes",
    path: "/clientes",
    component: () => import("/app/src/pages/clientes/index.vue")
  },
  {
    name: "usuarios",
    path: "/usuarios",
    component: () => import("/app/src/pages/usuarios/index.vue")
  },
  {
    name: "usuarios-tipos",
    path: "/usuarios/tipos",
    component: () => import("/app/src/pages/usuarios/tipos.vue")
  },
  {
    name: "aplicativos",
    path: "/aplicativos",
    component: () => import("/app/src/pages/aplicativos/index.vue")
  },
  {
    name: "bncc-etapas",
    path: "/bncc/etapas",
    component: () => import("/app/src/pages/bncc/etapas/index.vue")
  },
  {
    name: "equipamentos-id",
    path: "/equipamentos/:id()",
    component: () => import("/app/src/pages/equipamentos/[id].vue")
  },
  {
    name: "cursos-certificado",
    path: "/cursos/certificado",
    component: () => import("/app/src/pages/cursos/certificado.vue")
  },
  {
    name: "equipamentos",
    path: "/equipamentos",
    component: () => import("/app/src/pages/equipamentos/index.vue")
  },
  {
    name: "escolas-id-aulas",
    path: "/escolas/:id()/aulas",
    component: () => import("/app/src/pages/escolas/[id]/aulas.vue")
  },
  {
    name: "escolas-id",
    path: "/escolas/:id()",
    component: () => import("/app/src/pages/escolas/[id]/index.vue")
  },
  {
    name: "escolas-id-alunos",
    path: "/escolas/:id()/alunos",
    component: () => import("/app/src/pages/escolas/[id]/alunos.vue")
  },
  {
    name: "escolas-id-turmas",
    path: "/escolas/:id()/turmas",
    component: () => import("/app/src/pages/escolas/[id]/turmas.vue")
  },
  {
    name: "bncc-etapas-id",
    path: "/bncc/etapas/:id()",
    component: () => import("/app/src/pages/bncc/etapas/[id]/index.vue")
  },
  {
    name: "bncc-etapas-id-faixas",
    path: "/bncc/etapas/:id()/faixas",
    component: () => import("/app/src/pages/bncc/etapas/[id]/faixas.vue")
  },
  {
    name: "escolas-id-educadores",
    path: "/escolas/:id()/educadores",
    component: () => import("/app/src/pages/escolas/[id]/educadores.vue")
  },
  {
    name: "escolas-id-equipamentos",
    path: "/escolas/:id()/equipamentos",
    component: () => import("/app/src/pages/escolas/[id]/equipamentos.vue")
  }
]